(function(){
if(window.__gfInit)return;window.__gfInit=true;
function gal(){
var track=document.getElementById('gf-track');if(!track)return;
var count=document.getElementById('gf-count');
var dots=document.querySelectorAll('.gf-dot'),thumbs=document.querySelectorAll('.gf-thumb');
function upd(){var i=Math.round(track.scrollLeft/track.clientWidth);if(count)count.textContent=(i+1)+' / '+(dots.length||1);
dots.forEach(function(d,j){d.classList.toggle('is-active',j===i)});thumbs.forEach(function(t,j){t.classList.toggle('is-active',j===i)});}
track.addEventListener('scroll',function(){window.requestAnimationFrame(upd)},{passive:true});
thumbs.forEach(function(t){t.addEventListener('click',function(){track.scrollTo({left:track.clientWidth*(+t.dataset.i),behavior:'smooth'})})});
}
function buy(){
document.addEventListener('click',function(e){
var b=e.target.closest&&e.target.closest('.gf-buy');if(!b)return;
if(b.getAttribute('href')==='/rsi-btn-hook')return;
e.preventDefault();
var h=document.querySelector('[data-gf-selector]');var sel=h?h.getAttribute('data-gf-selector'):'';
if(sel){var r=document.querySelector(sel);if(r){r.click();return;}}
var f=document.querySelector('.gf-hidden-form form');
if(f){var s=f.querySelector('[type=submit]');if(s){s.click();}else if(f.requestSubmit){f.requestSubmit();}else{f.submit();}}
});
}
function init(){gal();buy();}
if(document.readyState==='loading'){document.addEventListener('DOMContentLoaded',init);}else{init();}
})();